import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {LocationType} from "../../../../commons/types/location.type";
import {NgxPermissionsService} from "ngx-permissions";
import {ServiceStatus} from "../../../../deliveries/constants/service-status.type";

require('./dashboard-services-table.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-services-table',
  templateUrl: './dashboard-services-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardServicesTableComponent implements OnInit, OnChanges {

  @Input() services: any[];
  @Input() isLeanData: boolean = false;
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onViewServiceRelatedTasks = new EventEmitter<any>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;
  public locationTypes: typeof LocationType = LocationType;
  public configZoneId: string;
  public hasFleetManagementPermission: boolean;
  public serviceStatus: typeof ServiceStatus = ServiceStatus;

  constructor(@Inject('splitService') private splitService, @Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService) {
  }

  ngOnInit() {
    this.configZoneId = this.splitService.getTimeZone();

    this.permissionsService.hasPermission('fleetManagement.vehicles.list').then((hasPermission) => {
      this.hasFleetManagementPermission = hasPermission;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agents) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
  }


  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }


  protected readonly LocationType = LocationType;
}
